import _ from "lodash";

import { isString } from "@cayuse/shared-react.utils.type-checks";

import components from "containers/Form/SimplifiedBuilder/Components";
import {
	findDisplayRulesByValues,
	getListOfValueFromDisplayRules,
} from "containers/Form/SimplifiedBuilder/Internal/DisplayRulesUtil";
import { getFormElementsFromFormConfig } from "containers/Form/SimplifiedBuilder/Internal/FormConverter";
import SimplifiedFormBuilderPalette from "containers/Form/SimplifiedBuilder/SimplifiedFormBuilderPalette/SimplifiedFormBuilderPalette";
import { encodeFlowableId, mapCayuseTypeToFieldType, mapFieldTypeToStencilInfo, dateNeedsToBeUpdated, attachmentsNeedsToBeUpdated } from "utils/forms";

import { DELETION_OPTIONS } from "./Components/AttachmentsCustomSettings";

// From SimplifiedFormBuilderView

export const getFullModelJson = modelJson => ({ rows: [ { cols: [ modelJson ] } ] });

export const findElementsWithRules = modelJson => {
	const { sections } = modelJson.extraSettings;
	const foundElementsWithRules = [];
	for (const section of sections) {
		for (const row of section.extraSettings.layoutDefinition.rows) {
			for (const col of row.cols) {
				let visibleField = col.visible;
				if (visibleField !== undefined && visibleField !== true && visibleField !== false) {
					const rules = getListOfValueFromDisplayRules(visibleField);
					const formElements = getFormElementsFromFormConfig(modelJson);
					const foundRules = findDisplayRulesByValues(rules, formElements);
					foundRules.forEach(rulesArray => {
						rulesArray.forEach(ruleSet => {
							foundElementsWithRules.push({
								dependentElementId: col.id,
								id: ruleSet.id,
								rules,
								value: ruleSet.value,
							});
						});
					});
				}
			}
		}
	}

	return foundElementsWithRules;
};

export const removeDeletedRuleGroupsFromModelJson = (modelJson, deletedRuleGroups) => {
	const { sections: oldSections } = modelJson.extraSettings;
	const sections = [ ...oldSections ];
	for (const ruleGroup of deletedRuleGroups) {
		for (const section of sections) {
			for (const row of section.extraSettings.layoutDefinition.rows) {
				for (const col of row.cols) {
					if(col.id === ruleGroup.dependentElementId) {
						let value = ruleGroup.value.replace(/(^{{|}}$)/g, "");
						ruleGroup.rules.forEach(ruleSet => {
							ruleSet.forEach(rule => {
								if (rule.includes(value) && isString(col.visible)) {
									col.visible = col.visible.replace(rule.trim(), "");
									let visibleStringDuplicate = col.visible.replace(/(^{{|}}$)/g, "").trim();
									if(col.visible.replace(/ /g,"") === "{{}}") {
										col.visible = true;
									} else {
										if (visibleStringDuplicate.startsWith("&&") || visibleStringDuplicate.startsWith("||")) {
											col.visible = `{{${visibleStringDuplicate.slice(4, visibleStringDuplicate.length)}}}`;
										}
										if (visibleStringDuplicate.endsWith("&&") || visibleStringDuplicate.endsWith("||")) {
											col.visible = `{{${visibleStringDuplicate.slice(0, -3)}}}`;
										}
									}
								}
							});
						});
					}
				}
			}
		}
	}

	return {
		...modelJson,
		extraSettings: {
			...modelJson.extraSettings,
			sections,
		}
	};
};


export const getPreparedModelJson = modelJsonToSave => {
	const modelJson = { ...modelJsonToSave };
	const { sections } = modelJson.extraSettings;

	for (const section of sections) {
		for (const row of section.extraSettings.layoutDefinition.rows) {
			for (const col of row.cols) {
				const multiOptionTypes = [ "select", "radio", "cayuseCheckboxes" ];
				const hasCayuseType = ("cayuseType" in col);
				const hasNewId = ("newId" in col);
				const { type = null, cayuseType = null } = col;

				const stencilInfo = mapFieldTypeToStencilInfo({ type, cayuseType });
				const questionType = mapCayuseTypeToFieldType({ type, cayuseType });
				const stencilId = col.designInfo.stencilId;

				if (stencilInfo && stencilInfo.stencilId !== stencilId) {
					col.designInfo = _.merge(col.designInfo, stencilInfo);
				}

				if (col.id) {
					col.id = hasNewId ? encodeFlowableId(col.newId) : col.id;
				}

				if (multiOptionTypes.includes(col.type)) {
					const items = col.extraSettings?.items;

					if (items && col.i18n?.en_us) {
						col.i18n.en_us.extraSettings = {
							items: [ ...items ]
						};
					}
				}

				if (dateNeedsToBeUpdated(col)) {
					col.extraSettings.storeWithoutTime = true;
				}

				if (attachmentsNeedsToBeUpdated(col)) {
					col.extraSettings.allowDelete = DELETION_OPTIONS[0].value;
				}

				if (hasCayuseType) {
					col.type = questionType;
				}
			}
		}
	}

	return getFullModelJson(modelJson);
};

export const findTabComponent = modelJson => {
	for (const row of modelJson.rows) {
		for (const col of row.cols) {
			if (col.type === "tabs") {
				return col;
			}
		}
	}

	return SimplifiedFormBuilderPalette.createNewElementByType(components, "tabs");
};

